export default {
  "ddbe9fdda1937e8067ae26d31e758a69": "确认订单收银台",
  "f60e3d2b532a6909bcdd56086693c022": "赠课：",
  "af4e086186dc7292e7fe6d5d4af8e070": "; 赠品：",
  "fe7ef76e50b4b8982b4986961a1e48be": "优惠券ID：",
  "20afd873cfb7cf8e96c084e603feb32b": "; 代金券ID：",
  "3d43a03f9649af819ca1cd07795d175d": "; 合计价格：",
  "64a7c518c73dc80c929280695ef7f730": "该商品暂时无法购买，请联系客服",
  "f274c45fe1f59f943b0635650644f18f": "未选择商品",
  "e5221976fe0061c364b2af35d755b2bd": "未选择地址",
  "1bc7355c38a9105d09bcc42e6beea46b": "未选择支付方式",
  "ac14a25586644305c664a0cfd0745924": "未检测到支付宝",
  "6d29c550cf3e1024a5bb939352a68a30": "确认订单收银台-立即支付按钮点击",
  "11033d3cd42c64a797ba83c8e1d411c1": "商城订单确认页_底部按钮",
  "3c8e67cdffc4247838f712b776ff133e": "商城订单确认页_优惠券点击",
  "3b8b66af6eacd73cd5646dbced53f092": "已下架",
  "fbd0b805b279b854b092c73047e59a53": "已售罄",
  "c4bb227feaf34e0fb7111d181c92ee48": "立即兑换",
  "813068367ffc4a2607ad35d2907e96d3": "立即签约",
  "f8b36b90160e00e89d9964d966acb108": "0元签约",
  "640cc04f9a9212f49be05074a04ccfa0": "立即支付",
  "920338af3975d212bed08b7e45cc8713": "下单页",
  "37111d7686ec1139e22178f585782461": "扩科组件曝光",
  "1dbe524f32b40d27c74c2426ee899732": "参数错误!",
  "1be65297d44b755319cf6ea4a2b9659e": "签约中...",
  "e5e6097c06fd5f5d3e87ae462adc8f23": "支付中...",
  "2d962569f8d1c75433f8d9fa3d1fa5f6": "商品明细",
  "fc47c520fb3452ac8dcd243e54a8f2e1": "价格明细",
  "1d6f71e5c4c07373595e37b34ded4a11": "支付方式",
  "07710d908fd710218e2f38df3bc99d90": "您确定要放弃支付吗？",
  "74e152f4159cf367bdbd756936b73a86": "支付结果确认中",
  "9adb2a2ad039b13485a06ffd4ec9f229": "请勿重复支付或离开此页面哦"
}
